import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@tellescope/tanstack-query";
import { getRouteComponent } from "./get-route-component";
import { ROUTES_CONFIG } from "./routes-config";
import type { ShouldShowContext } from "./types";
import { useMemo } from "react";
import { useOrgFeatures } from "../permissions";

export const RouterContent = () => {
  const { session, selectedOrganization, currentUser, isAuthenticated, isInitializing, isAdmin } = useAuth();
  const { isFeatureEnabled } = useOrgFeatures();

  const shouldShowContext: ShouldShowContext | null =
    isAuthenticated && !isInitializing && currentUser && selectedOrganization
      ? { session, selectedOrganization, currentUser, isAdmin }
      : null;

  const defaultRoute = useMemo(() => {
    if (isFeatureEnabled("dashboard")) return "/dashboard";

    return (
      Object.entries(ROUTES_CONFIG).find(
        ([, config]) => "featureName" in config && config.featureName && isFeatureEnabled(config.featureName)
      )?.[0] ?? "/dashboard"
    );
  }, [isFeatureEnabled]);

  return (
    <Routes>
      {Object.entries(ROUTES_CONFIG).map(([path, config]) =>
        getRouteComponent({ path, ...config }, { shouldShowContext, isFeatureEnabled })
      )}

      {/* Default redirect to dashboard (or first featureName) */}
      <Route path="/" element={<Navigate to={defaultRoute} replace />} />

      {/* Catch all route - redirect to dashboard */}
      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
};
